import { useQuery } from 'react-query';

import { QUERY_KEYS } from 'consts/queryKeys';
import { getPaymentModels } from 'modules/settings/api';

export const useQueryPaymentModels = () =>
  useQuery(QUERY_KEYS.SETTINGS_PAYMENT_MODELS, getPaymentModels, {
    keepPreviousData: true,
    staleTime: 5 * 60 * 1000,
  });
